var horarios;
var horariosResizeBound = false;
var HORA_CORTE_TARDES = 1500;

export function initHorariosPage() {
  if (!$('#tabla_horario_mananas').length) {
    return;
  }

  init_horarios();

  if (!horariosResizeBound) {
    $(window).on("resize.horarios", onHorariosResize);
    horariosResizeBound = true;
  }

  onHorariosResize();
}

export function destroyHorariosPage() {
  if (horariosResizeBound) {
    $(window).off("resize.horarios");
    horariosResizeBound = false;
  }
  horarios = null;
}

function init_horarios() {
  console.log("[tabla_horarios.js](init_horarios)!");
  horarios = new Horarios();
}

function onHorariosResize() {
  var newWidth = window.innerWidth;
  var ratio;
  var breakP1 = 990;

  if (newWidth >= breakP1) {
    ratio = 1;
  } else if (newWidth < breakP1 && newWidth > 768) {
    ratio = (newWidth - 20) / 990;
  } else {
    ratio = newWidth / 990;
  }

  if (ratio < 1) {
    $(".tabla_horario_cont").css({ transform: "scale(" + ratio + ")" });
  } else {
    $(".tabla_horario_cont").css({ transform: "scale(1)" });
  }
}

function Horarios() {
  console.log("(Horarios.CONSTRUCTORA)!");
  this.jsondata;
  var donde = this;
  $.getJSON("pages/horarios-data.php?nocache=" + (new Date()).getTime(), function (data) {
    donde.onHorariosCargados(data);
    donde.crearTablas();
  });
}

Horarios.prototype.obtenerRangoHorario = function (tipo, esTarde, horaInicioBase, horaFinBase) {
  var horaInicio = horaInicioBase;
  var horaFin = horaFinBase;
  var clases = this.jsondata[tipo] || [];

  for (var i = 0; i < clases.length; i++) {
    var hora = Number(clases[i].hora);
    var perteneceAlPeriodo = esTarde ? hora >= HORA_CORTE_TARDES : hora < HORA_CORTE_TARDES;

    if (perteneceAlPeriodo) {
      var horaCompleta = Math.floor(hora / 100) * 100;
      horaInicio = Math.min(horaInicio, horaCompleta);
      horaFin = Math.max(horaFin, horaCompleta);
    }
  }

  return [horaInicio, horaFin];
};

Horarios.prototype.crearTablas = function () {
  var principalMananas = this.obtenerRangoHorario("clases", false, 900, 1400);
  var principalTardes = this.obtenerRangoHorario("clases", true, 1700, 2000);
  var sueloMananas = this.obtenerRangoHorario("clases_SUELO", false, 900, 1200);
  var sueloTardes = this.obtenerRangoHorario("clases_SUELO", true, 1700, 2000);

  this.tabla_mananas = new TablaHoraria(this, "#tabla_horario_mananas", principalMananas[0], principalMananas[1], "clases");
  this.tabla_tardes = new TablaHoraria(this, "#tabla_horario_tardes", principalTardes[0], principalTardes[1], "clases");
  this.SUELO_tabla_mananas = new TablaHoraria(this, "#SUELO_tabla_horario_mananas", sueloMananas[0], sueloMananas[1], "clases_SUELO");
  this.SUELO_tabla_tardes = new TablaHoraria(this, "#SUELO_tabla_horario_tardes", sueloTardes[0], sueloTardes[1], "clases_SUELO");
};

Horarios.prototype.onHorariosCargados = function (jsonData) {
  console.log("(Horarios.onHorariosCargados)!");
  this.jsondata = jsonData;
  this.actualizarFechasActualizacion();
  var aviso = jsonData.aviso || '';
  var cont = document.getElementById('horarios-aviso-cont');
  if (cont) {
    if (aviso) {
      document.getElementById('horarios-aviso').textContent = aviso;
      cont.style.display = '';
    } else {
      cont.style.display = 'none';
    }
  }
};

var _mesesES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

function formatearMesAnyo(isoStr) {
  if (!isoStr) return null;
  var d = new Date(isoStr.replace(' ', 'T'));
  return _mesesES[d.getMonth()] + ' ' + d.getFullYear();
}

Horarios.prototype.actualizarFechasActualizacion = function () {
  var textoP = formatearMesAnyo(this.jsondata.last_updated_principal);
  var textoS = formatearMesAnyo(this.jsondata.last_updated_suelo);
  if (textoP) {
    var labelP = '(actualizado ' + textoP + ')';
    $('#tabla_horario_mananas').prev('.titular_negro').find('.anexo_seccion').text(labelP);
    $('#tabla_horario_tardes').prev('.titular_negro').find('.anexo_seccion').text(labelP);
  }
  if (textoS) {
    var labelS = '(actualizado ' + textoS + ')';
    $('#SUELO_tabla_horario_mananas').prev('.titular_negro').find('.anexo_seccion').text(labelS);
    $('#SUELO_tabla_horario_tardes').prev('.titular_negro').find('.anexo_seccion').text(labelS);
  }
};

function TablaHoraria(_horariosRef, _selector, _hora_inicio, _hora_fin, _tipo) {
  this.horariosRef = _horariosRef;
  this.selector = _selector;
  this.hora_inicio = _hora_inicio;
  this.hora_fin = _hora_fin;
  this.tipo = _tipo;
  this.jsondata = this.horariosRef.jsondata;
  this.crear_clasesLib();
  this.crear_dias();
  this.crear_horasGenerales();
  this.anadir_clases();
  this.crearHTML();
}

TablaHoraria.prototype.crear_dias = function () {
  this.dias = new Datos();
  for (var i = 0; i < 5; i++) {
    var diaId = "dia_" + i;
    var dia = new Dia(diaId, i, this);
    this.dias.nuevoItem(dia.diaId, dia);
  }
};

TablaHoraria.prototype.crear_horasGenerales = function () {
  this.horasGenerales = new HorasGenerales();
  var hora_min = Math.floor(this.hora_inicio / 100);
  var hora_max = Math.floor(this.hora_fin / 100);
  for (var i = hora_min; i <= hora_max; i++) {
    var horaId = "hora_" + i;
    var horaGeneral = new HoraGeneral(horaId, i, this.tablaRef);
    this.horasGenerales.data.nuevoItem(horaGeneral.horaId, horaGeneral);
  }
};

TablaHoraria.prototype.anadir_clases = function () {
  for (var i = 0; i < this.clasesLib.arrayItems.length; i++) {
    var claseId = this.clasesLib.arrayItems[i];
    var clase = this.clasesLib.getItem(claseId);
    var diaNum = clase.dia;
    var dia = this.dias.getItem("dia_" + diaNum);
    dia.nuevaClase(clase);
    this.horasGenerales.nuevaClase(clase);
  }
};

TablaHoraria.prototype.formatearHoraMin = function (horaMin) {
  var parteHora = Math.floor(horaMin / 100);
  if (parteHora < 10) parteHora = "0" + parteHora;
  var parteMin = horaMin - (parteHora * 100);
  if (parteMin < 10) parteMin = "0" + parteMin;
  return parteHora + ":" + parteMin;
};

TablaHoraria.prototype.crearHTML = function () {
  this.crear_html_celdas();
  this.crear_html_clases();
};

TablaHoraria.prototype.crear_html_celdas = function () {
  var cadenaHTML = "";
  var hora_min = Math.floor(this.hora_inicio / 100);
  var hora_max = Math.floor(this.hora_fin / 100);
  for (var i = hora_min; i <= hora_max; i++) {
    cadenaHTML += '<tr class="row_hora hora_' + i + '">';
    cadenaHTML += '<td class="cell_day dia_0"></td>';
    cadenaHTML += '<td class="cell_day dia_1"></td>';
    cadenaHTML += '<td class="cell_day dia_2"></td>';
    cadenaHTML += '<td class="cell_day dia_3"></td>';
    cadenaHTML += '<td class="cell_day dia_4"></td>';
    cadenaHTML += '</tr>';
  }
  $(this.selector + " tbody").append(cadenaHTML);
};

TablaHoraria.prototype.crear_html_clases = function () {
  for (var i = 0; i < this.dias.arrayItems.length; i++) {
    var diaId = this.dias.arrayItems[i];
    var dia = this.dias.getItem(diaId);
    for (var j = 0; j < dia.horas.arrayItems.length; j++) {
      var horaId = dia.horas.arrayItems[j];
      var hora = dia.horas.getItem(horaId);
      var num_clases_dia = hora.clases.arrayItems.length;
      var numTramos_general = this.horasGenerales.data.getItem(horaId).get_numTramos();
      var array_tramos_dia = hora.array_tramos;
      var array_tramos_general = this.horasGenerales.data.getItem(horaId).array_tramos;
      var esDoble = (numTramos_general == 2 || num_clases_dia == 2);

      if (esDoble) {
        if (num_clases_dia == 0) {
          this.crear_html_doble_vacio(horaId, diaId);
        } else if (num_clases_dia == 1) {
          var claseId = hora.get_arrayclasesHora(array_tramos_dia[0])[0];
          var clase = this.clasesLib.getItem(claseId);
          var posClase = array_tramos_general.indexOf(clase.hora);
          if (posClase == 0) {
            this.crear_html_tipo_doble_1clase_sup(horaId, diaId, claseId);
          } else {
            this.crear_html_tipo_doble_1clase_inf(horaId, diaId, claseId);
          }
        } else if (num_clases_dia == 2 && array_tramos_dia.length == 1) {
          this.crear_html_tipo_doble_2clases_1tramo(horaId, diaId, hora.clases.arrayItems[0], hora.clases.arrayItems[1]);
        } else if (num_clases_dia == 2 && array_tramos_dia.length == 2) {
          this.crear_html_tipo_doble_2clases_2tramos(horaId, diaId, hora.clases.arrayItems[0], hora.clases.arrayItems[1]);
        }
      } else {
        if (num_clases_dia == 0) {
          this.crear_html_tipo_sencillo_vacio(horaId, diaId);
        } else if (num_clases_dia == 1) {
          var claseId = hora.get_arrayclasesHora(array_tramos_dia[0])[0];
          this.crear_html_tipo_sencillo_1clase(horaId, diaId, claseId);
        }
      }
    }
  }
};

TablaHoraria.prototype.crear_html_tipo_sencillo_vacio = function (horaId, diaId) {
  var selectorCelda = this.selector + " ." + horaId + " ." + diaId;
  $(selectorCelda).append('<div class="cell_hora cell_hora_vacio"><div class="cell_hora_hr"></div></div>');
};

TablaHoraria.prototype.crear_html_tipo_sencillo_1clase = function (horaId, diaId, claseId) {
  var clase = this.clasesLib.getItem(claseId);
  var tipo = this.get_claseTipo(clase);
  var selectorCelda = this.selector + " ." + horaId + " ." + diaId;
  var thContent = clase.monitora
    ? tipo.nombre + '<br><span class="monitora">' + clase.monitora + '</span>'
    : tipo.nombre;
  var cadenaHTML = '<div class="cell_hora"><div class="cell_hora_hr">' + this.formatearHoraMin(clase.hora) + '</div><div class="cell_actividad actividad_1"><table class="tabla_actividad"><thead><tr><th class="cabecera_actividad cell_small" style="background-color:' + tipo.color + '">' + thContent + '</th></tr></thead></table></div></div>';
  $(selectorCelda).append(cadenaHTML);
};

TablaHoraria.prototype.crear_html_doble_vacio = function (horaId, diaId) {
  var selectorCelda = this.selector + " ." + horaId + " ." + diaId;
  $(selectorCelda).append('<div class="cell_hora cell_hora_vacio cell_hora_vacio_doble"><div class="cell_hora_hr"></div></div>');
};

TablaHoraria.prototype.crear_html_tipo_doble_1clase_sup = function (horaId, diaId, claseId) {
  var clase = this.clasesLib.getItem(claseId);
  var tipo = this.get_claseTipo(clase);
  var selectorCelda = this.selector + " ." + horaId + " ." + diaId;
  var thContent = clase.monitora ? tipo.nombre + '<br><span class="monitora">' + clase.monitora + '</span>' : tipo.nombre;
  var cadenaHTML = '<div class="cell_hora"><div class="cell_hora_hr">' + this.formatearHoraMin(clase.hora) + '</div><div class="cell_actividad actividad_1"><table class="tabla_actividad"><thead><tr><th class="cabecera_actividad cell_small" style="background-color:' + tipo.color + '">' + thContent + '</th></tr></thead></table></div></div><div class="cell_hora cell_hora_vacio cell_hora_inf"><div class="cell_hora_hr"></div></div>';
  $(selectorCelda).append(cadenaHTML);
};

TablaHoraria.prototype.crear_html_tipo_doble_1clase_inf = function (horaId, diaId, claseId) {
  var clase = this.clasesLib.getItem(claseId);
  var tipo = this.get_claseTipo(clase);
  var selectorCelda = this.selector + " ." + horaId + " ." + diaId;
  var thContent = clase.monitora ? tipo.nombre + '<br><span class="monitora">' + clase.monitora + '</span>' : tipo.nombre;
  var cadenaHTML = '<div class="cell_hora cell_hora_vacio"><div class="cell_hora_hr"></div></div><div class="cell_hora cell_hora_inf"><div class="cell_hora_hr">' + this.formatearHoraMin(clase.hora) + '</div><div class="cell_actividad actividad_1"><table class="tabla_actividad"><thead><tr><th class="cabecera_actividad cell_small" style="background-color:' + tipo.color + '">' + thContent + '</th></tr></thead></table></div></div>';
  $(selectorCelda).append(cadenaHTML);
};

TablaHoraria.prototype.crear_html_tipo_doble_2clases_1tramo = function (horaId, diaId, clase1Id, clase2Id) {
  var clase1 = this.clasesLib.getItem(clase1Id);
  var tipo1 = this.get_claseTipo(clase1);
  var clase2 = this.clasesLib.getItem(clase2Id);
  var tipo2 = this.get_claseTipo(clase2);
  var selectorCelda = this.selector + " ." + horaId + " ." + diaId;
  var th1 = clase1.monitora ? tipo1.nombre + '<br><span class="monitora">' + clase1.monitora + '</span>' : tipo1.nombre;
  var th2 = clase2.monitora ? tipo2.nombre + '<br><span class="monitora">' + clase2.monitora + '</span>' : tipo2.nombre;
  var cadenaHTML = '<div class="cell_hora"><div class="cell_hora_hr">' + this.formatearHoraMin(clase1.hora) + '</div><div class="cell_actividad actividad_1"><table class="tabla_actividad"><thead><tr><th class="cabecera_actividad" style="background-color:' + tipo1.color + '">' + th1 + '</th></tr></thead></table></div><div class="cell_actividad actividad_2"><table class="tabla_actividad"><thead><tr><th class="cabecera_actividad" style="background-color:' + tipo2.color + '">' + th2 + '</th></tr></thead></table></div></div>';
  $(selectorCelda).append(cadenaHTML);
};

TablaHoraria.prototype.crear_html_tipo_doble_2clases_2tramos = function (horaId, diaId, clase1Id, clase2Id) {
  var clase1 = this.clasesLib.getItem(clase1Id);
  var tipo1 = this.get_claseTipo(clase1);
  var clase2 = this.clasesLib.getItem(clase2Id);
  var tipo2 = this.get_claseTipo(clase2);
  var selectorCelda = this.selector + " ." + horaId + " ." + diaId;
  var th1 = clase1.monitora ? tipo1.nombre + '<br><span class="monitora">' + clase1.monitora + '</span>' : tipo1.nombre;
  var th2 = clase2.monitora ? tipo2.nombre + '<br><span class="monitora">' + clase2.monitora + '</span>' : tipo2.nombre;
  var cadenaHTML = '<div class="cell_hora"><div class="cell_hora_hr">' + this.formatearHoraMin(clase1.hora) + '</div><div class="cell_actividad actividad_1"><table class="tabla_actividad"><thead><tr><th class="cabecera_actividad cell_small" style="background-color:' + tipo1.color + '">' + th1 + '</th></tr></thead></table></div></div><div class="cell_hora cell_hora_inf"><div class="cell_hora_hr">' + this.formatearHoraMin(clase2.hora) + '</div><div class="cell_actividad actividad_1"><table class="tabla_actividad"><thead><tr><th class="cabecera_actividad cell_small" style="background-color:' + tipo2.color + '">' + th2 + '</th></tr></thead></table></div></div>';
  $(selectorCelda).append(cadenaHTML);
};

TablaHoraria.prototype.crear_clasesLib = function () {
  this.clasesLib = new Datos();
  for (var i = 0; i < this.jsondata[this.tipo].length; i++) {
    var claseItem = this.jsondata[this.tipo][i];
    var claseId = "d" + claseItem.dia + "_h" + claseItem.hora + "_0";
    var existe = this.clasesLib.evalExiste(claseId);
    if (Math.floor(claseItem.hora / 100) * 100 >= this.hora_inicio && Math.floor(claseItem.hora / 100) * 100 <= this.hora_fin) {
      if (!existe) {
        claseItem.claseId = claseId;
        this.clasesLib.nuevoItem(claseItem.claseId, claseItem);
      } else {
        var creado = false;
        var contador = 1;
        while (!creado) {
          var tempId = "d" + claseItem.dia + "_h" + claseItem.hora + "_" + contador;
          contador++;
          if (!this.clasesLib.evalExiste(tempId)) {
            creado = true;
            claseItem.claseId = tempId;
            this.clasesLib.nuevoItem(claseItem.claseId, claseItem);
            break;
          }
        }
      }
    }
  }
};

TablaHoraria.prototype.get_claseTipo = function (clase) {
  for (var i = 0; i < this.jsondata.clases_tipos.length; i++) {
    var item = this.jsondata.clases_tipos[i];
    if (clase.tipo == item.tipo) return item;
  }
  return null;
};

function Dia(_diaId, _diaNum, _tablaRef) {
  this.diaId = _diaId;
  this.diaNum = _diaNum;
  this.tablaRef = _tablaRef;
  this.horas = new Datos();
  var hora_min = Math.floor(this.tablaRef.hora_inicio / 100);
  var hora_max = Math.floor(this.tablaRef.hora_fin / 100);
  for (var i = hora_min; i <= hora_max; i++) {
    var horaId = "hora_" + i;
    var hora = new HoraDia(horaId, i, this.tablaRef);
    this.horas.nuevoItem(hora.horaId, hora);
  }
}

Dia.prototype.nuevaClase = function (clase) {
  var horaNum = Math.floor(clase.hora / 100);
  var horaId = "hora_" + horaNum;
  this.horas.getItem(horaId).nuevaClase(clase);
};

function HorasGenerales() {
  this.data = new Datos();
}

HorasGenerales.prototype.nuevaClase = function (clase) {
  var horaNum = Math.floor(clase.hora / 100);
  var horaId = "hora_" + horaNum;
  var horaGeneral;
  if (!this.data.evalExiste(horaId)) {
    horaGeneral = new HoraGeneral(horaId, horaNum);
    this.data.nuevoItem(horaGeneral.horaId, horaGeneral);
  } else {
    horaGeneral = this.data.getItem(horaId);
  }
  horaGeneral.nuevaClase(clase);
};

function HoraGeneral(_horaId, _horaNum) {
  this.horaId = _horaId;
  this.horaNum = _horaNum;
  this.array_tramos = [];
}

HoraGeneral.prototype.get_numTramos = function () {
  return this.array_tramos.length;
};

HoraGeneral.prototype.nuevaClase = function (clase) {
  if (this.array_tramos.indexOf(clase.hora) == -1) {
    this.array_tramos.push(clase.hora);
  }
  this.array_tramos.sort(function (a, b) { return a - b; });
};

function HoraDia(_horaId, _horaNum, _tableRef) {
  this.horaId = _horaId;
  this.horaNum = _horaNum;
  this.tableRef = _tableRef;
  this.clases = new Datos();
  this.array_tramos = [];
}

HoraDia.prototype.get_numTramos = function () {
  return this.array_tramos.length;
};

HoraDia.prototype.get_arrayclasesHora = function (hora) {
  var arrayTemp = [];
  for (var i = 0; i < this.clases.arrayItems.length; i++) {
    var claseId = this.clases.arrayItems[i];
    var clase = this.clases.getItem(claseId);
    if (clase.hora == hora) arrayTemp.push(claseId);
  }
  return arrayTemp;
};

HoraDia.prototype.nuevaClase = function (clase) {
  this.clases.nuevoItem(clase.claseId, clase);
  if (this.array_tramos.indexOf(clase.hora) == -1) {
    this.array_tramos.push(clase.hora);
  }
  this.array_tramos.sort(function (a, b) { return a - b; });
};

function Datos() {
  this.dataItems = {};
  this.arrayItems = [];
}

Datos.prototype.nuevoItem = function (itemId, item) {
  if (!this.evalExiste(itemId)) {
    this.arrayItems.push(itemId);
    this.dataItems[itemId] = item;
  }
};

Datos.prototype.getItem = function (itemId) {
  return this.evalExiste(itemId) ? this.dataItems[itemId] : undefined;
};

Datos.prototype.getItemAt = function (pos) {
  if (pos < this.arrayItems.length) {
    return this.dataItems[this.arrayItems[pos]];
  }
  return undefined;
};

Datos.prototype.evalExiste = function (itemId) {
  for (var i = 0; i < this.arrayItems.length; i++) {
    if (this.arrayItems[i] == itemId) return true;
  }
  return false;
};

Datos.prototype.quitarItem = function (itemId) {
  if (this.evalExiste(itemId)) {
    this.dataItems[itemId] = {};
    this.arrayItems = this.arrayItems.filter(function (v) { return v != itemId; });
  }
};

Datos.prototype.resetear = function () {
  this.dataItems = {};
  this.arrayItems = [];
};
